import { useQuery } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import {
  WithdrawalFeesDto,
  WithdrawalSettlementDto,
} from '@/features/dashboard/bookingChanges/types/dto/WithdrawalDto.ts';

/**
 * Rozliczenie rezygnacji policzone przez backend — tym samym kalkulatorem,
 * którym policzy je wprowadzenie, więc operator widzi dokładnie to, co się
 * stanie.
 *
 * Zapytanie milczy, dopóki nie wskazano nikogo: backend odrzuca pustą listę,
 * a rozliczenie „nikogo” i tak nie istnieje.
 */
const useWithdrawalPreview = (
  bookingId: string,
  participantIds: string[],
  fees: WithdrawalFeesDto,
) => {
  const request = { participantIds, fees };

  return useQuery<WithdrawalSettlementDto>({
    // Klucz niesie treść żądania, bo podgląd zmienia się z każdym wyborem osoby
    // i każdą zmianą potrącenia.
    queryKey: bookingChangesApiQueryKeys.withdrawalPreview(
      bookingId,
      JSON.stringify(request),
    ),
    queryFn: () => bookingChangesApi.previewWithdrawal(bookingId, request),
    enabled: participantIds.length > 0,
  });
};

export default useWithdrawalPreview;
